export const USER_TOKEN_KEY = 'token'
export const USER_REFRESH_TOKEN_KEY = 'refreshToken'
